// extracted by mini-css-extract-plugin
export var closeButton = "_2w-0";